import { createSelector } from "reselect";
import { sectionsSelector } from "../sections_selector";

export const otpVerificationSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.otpVerification;
  }
);
